import { render } from "./CompanyCreditDisplay.vue?vue&type=template&id=bfd8391a&scoped=true"
import script from "./CompanyCreditDisplay.vue?vue&type=script&lang=js"
export * from "./CompanyCreditDisplay.vue?vue&type=script&lang=js"

import "./CompanyCreditDisplay.vue?vue&type=style&index=0&id=bfd8391a&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd8391a"]])

export default __exports__